import classnames from 'classnames';
import React from 'react';
import { Field, useField } from 'react-final-form';

import { FormTextarea } from '../../../../interfaces';
import { useClipboardPasting, useFormInput } from '../../../../libs/hooks';
import { InputLabelComponent } from '../../input-label';
import { InputMessageComponent } from '../../input-message';

export const TextAreaComponent: React.FC<FormTextarea> = React.memo((props: FormTextarea) => {
  const {
    className,
    clipboardDisabled = false,
    description,
    disabled,
    label,
    maxChars,
    name,
    required = true,
    validators,
    ...rest
  } = props;
  const { disabledPasteHandler } = useClipboardPasting(clipboardDisabled);

  const { id, texts, validate } = useFormInput({
    description,
    disabled,
    label,
    name,
    required,
    validators,
  });

  const metaField = useField(id, { subscription: { error: true, touched: true, value: true } });

  const count = metaField.input.value.length;
  const offlimit = maxChars ? count > maxChars : false;
  const maxLength = maxChars ? maxChars + 1 : undefined;
  const error = metaField.meta.touched && metaField.meta.error;

  return (
    <div
      className={classnames('fr-input-group', className, {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'fr-input-group--error': !!error,
      })}>
      <InputLabelComponent disabled={disabled} id={id} texts={texts} />
      <Field
        {...rest}
        aria-multiline
        aria-describedby={`${id}-messages`}
        className={classnames('fr-input', {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'fr-input--error': !!error,
        })}
        component="textarea"
        id={id}
        maxLength={maxLength}
        name={id}
        required={required}
        validate={validate}
        onPaste={disabledPasteHandler}
      />
      <InputMessageComponent error={error} id={id} />
      {maxChars && (
        <p aria-live="polite" className="fr-text--xs fr-mt-1w">
          <span className={classnames({ offlimit })}>{count}</span>
          &nbsp;/&nbsp;{maxChars}&nbsp;caractères
        </p>
      )}
    </div>
  );
});

TextAreaComponent.displayName = 'TextAreaComponent';
